import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarToNutshell from './icon-calendar-to-nutshell.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    if (validProps.width && validProps.height) {
        delete validProps.height;
    }

    return <CalendarToNutshell {...validProps} />;
}
SvgComponent.iconName = 'calendarToNutshell';

/**
 * @deprecated This is a legacy icon
 */
export const CalendarToNutshellIcon = svgIconWrapper(SvgComponent);
